import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { FREE_TOOLS_COUNT } from './constants';

export const UserAccessBadge = ({ userAccessStatus }) => {
  if (!userAccessStatus?.badge) return null;

  return (
    <div className="mb-4 flex items-center gap-2">
      <Badge className={cn(
        "px-3 py-1",
        userAccessStatus.badge.type === 'founder' && "bg-gradient-to-r from-amber-500 to-yellow-500 text-white",
        userAccessStatus.badge.type === 'early_adopter' && "bg-gradient-to-r from-blue-500 to-cyan-500 text-white",
        userAccessStatus.badge.type === 'premium' && "bg-gradient-to-r from-purple-500 to-indigo-500 text-white"
      )}>
        <span className="mr-1">{userAccessStatus.badge.icon}</span>
        {userAccessStatus.badge.label}
      </Badge>
      <span className="text-sm text-gray-500">
        {userAccessStatus.tools_accessible} of {userAccessStatus.total_tools} tools accessible
      </span>
    </div>
  );
};

export const FreeUserUpgradeBanner = ({ effectivePremiumAccess, userAccessStatus }) => {
  const navigate = useNavigate();

  if (effectivePremiumAccess || userAccessStatus?.badge) return null;

  // Use the actual free tools count from constants
  const freeToolsCount = FREE_TOOLS_COUNT;
  const totalTools = userAccessStatus?.total_tools || 21;

  return (
    <div className="mb-6 bg-gradient-to-r from-purple-50 to-indigo-50 border border-purple-200 rounded-xl p-4">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-xl flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <div>
            <h4 className="font-semibold text-gray-900">Unlock All Premium Tools</h4>
            <p className="text-sm text-gray-600">
              You have access to {freeToolsCount} free tools. Upgrade to unlock all {totalTools} tools.
            </p>
          </div>
        </div>
        <Button
          onClick={() => navigate('/pricing')}
          className="bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 whitespace-nowrap"
        >
          Upgrade Now
        </Button>
      </div>
    </div>
  );
};
